import { render, staticRenderFns } from "./returnees.vue?vue&type=template&id=06a445c0&scoped=true&"
import script from "./returnees.vue?vue&type=script&lang=js&"
export * from "./returnees.vue?vue&type=script&lang=js&"
import style0 from "./returnees.vue?vue&type=style&index=0&id=06a445c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a445c0",
  null
  
)

export default component.exports